<app-header [forceLightBackground]="true"></app-header>
<div class="provider-dataset">
  <div class="provider-dataset--layout">
    <app-org-admin-sidebar *ngIf="isOrgAdminRoute" class="provider-dataset--sidebar"></app-org-admin-sidebar>
    <app-provider-sidebar *ngIf="!isOrgAdminRoute" class="provider-dataset--sidebar"></app-provider-sidebar>
    <div class="provider-dataset--content">
      <app-page-header></app-page-header>
      <div class="dataset-container">
        <!-- Step 4 Template -->
        <ng-template #step4Template>
          <div class="step-content">
            <h2 class="step-title">Upload files</h2>
            
            <!-- Upload Options -->
            <div class="upload-options">
              <div class="form-fields">
                <div class="upload-options__row">
                <div
                  *ngFor="let option of uploadOptions"
                  class="upload-option-card"
                  [class.active]="selectedUploadOption === option.value"
                  [class.disabled]="isUploadOptionDisabled(option.value)"
                  (click)="!isUploadOptionDisabled(option.value) && selectUploadOption(option.value)"
                >
                  <div class="upload-option-card__header">
                    <div class="upload-option-card__icon">
                      <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M21 15V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V15" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M7 14L12 9L17 14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M12 9V21" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                    </div>
                    <h3 class="upload-option-card__title">{{ option.label }}</h3>
                  </div>
                  <div class="upload-option-card__content">
                    <p class="upload-option-card__description">
                      {{ option.description }}
                    </p>
                  </div>
                </div>
                </div>
              </div>
            </div>

            <!-- File Upload Section (shown when Upload File is selected) -->
            <div *ngIf="isUploadFileSelected()" class="file-upload-section">
              <div class="file-upload-header">
                <h3 class="file-upload-title">Upload Files</h3>
                <p class="file-upload-subtitle">Drag and drop files or folders, or click to browse. Any file type is allowed; folder structure is preserved.</p>
              </div>

              <!-- Drag and Drop Area -->
              <div 
                class="drop-area"
                [class.active]="dragActive"
                (dragover)="onDragOver($event)"
                (dragleave)="onDragLeave($event)"
                (drop)="onDrop($event)"
              >
                <div class="drop-message">
                  <div class="text-center">
                    <svg class="drop-icon" width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M21 15V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V15" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M7 10L12 5L17 10" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M12 5V17" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    <p class="drop-text">
                      Drag and drop your files or folders here, or browse
                      <button
                        type="button"
                        class="browse-button"
                        (click)="fileInput.click()"
                      >
                        files
                      </button>
                      or
                      <button
                        type="button"
                        class="browse-button"
                        (click)="folderInput.click()"
                      >
                        a folder
                      </button>
                    </p>
                    <p class="file-types-hint">
                      All file types are allowed. Folders keep their directory structure.
                    </p>
                  </div>
                </div>
                <input
                  #fileInput
                  type="file"
                  multiple
                  (change)="onFileSelected($event)"
                  class="d-none"
                />
                <input
                  #folderInput
                  type="file"
                  webkitdirectory
                  (change)="onFileSelected($event)"
                  class="d-none"
                />
              </div>

              <!-- File tree -->
              <div *ngIf="selectedFiles.length > 0 || uploadedFiles.length > 0" class="selected-files-list">
                <div class="selected-files-header file-tree-header">
                  <h4 class="selected-files-title">
                    Files ({{ uploadedFiles.length + selectedFiles.length }})
                    <span *ngIf="selectedFiles.length > 0 && uploadedFiles.length > 0" class="file-tree-sub">
                      {{ uploadedFiles.length }} uploaded · {{ selectedFiles.length }} pending
                    </span>
                  </h4>
                  <div class="file-tree-toolbar" *ngIf="hasFolders()">
                    <button type="button" class="btn-link" (click)="expandAllFolders()">Expand all</button>
                    <button type="button" class="btn-link" (click)="collapseAllFolders()">Collapse all</button>
                  </div>
                </div>

                <!-- Overall upload progress -->
                <div class="upload-summary" *ngIf="getTotalFileCount() > 0">
                  <div class="upload-summary__text">
                    <span><strong>{{ getCompletedFileCount() }}</strong> of <strong>{{ getTotalFileCount() }}</strong> files uploaded</span>
                    <span *ngIf="getFailedFileCount() > 0" class="upload-summary__failed">{{ getFailedFileCount() }} failed</span>
                  </div>
                  <div class="progress-bar">
                    <div class="progress-fill" [style.width.%]="getOverallProgressPercent()"></div>
                  </div>
                </div>

                <div class="file-tree-scroller">
                  <ng-container *ngFor="let row of getTreeRows(); trackBy: trackTreeRow">
                    <!-- Folder row -->
                    <div
                      *ngIf="row.kind === 'folder'"
                      class="tree-row tree-folder"
                      [style.padding-left.px]="8 + row.depth * 20"
                      (click)="toggleFolder(row.key)"
                      role="button"
                      [attr.aria-expanded]="!row.collapsed"
                    >
                      <span class="tree-chevron-wrap" [class.expanded]="!row.collapsed"><svg class="tree-chevron" width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 6l6 6-6 6" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg></span>
                      <span class="file-icon tree-folder-icon"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></span>
                      <span class="file-name">{{ row.name }}</span>
                      <span class="tree-folder-count">{{ row.count }} {{ row.count === 1 ? 'file' : 'files' }}</span>
                    </div>

                    <!-- Pending (selected) file row -->
                    <div
                      *ngIf="row.kind === 'selected'"
                      class="tree-row selected-file-item"
                      [style.padding-left.px]="8 + row.depth * 20"
                    >
                      <div class="file-info">
                        <div class="file-icon"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M14 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V8L14 2Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M14 2V8H20" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg></div>
                        <div class="file-details">
                          <span class="file-name" [title]="getFilePath(row.ref)">{{ row.name }}</span>
                          <span class="file-size">{{ getFileSize(row.ref.size) }}</span>
                        </div>
                      </div>
                      <div class="file-actions-buttons">
                        <button type="button" class="btn-icon btn-upload" (click)="uploadSingleFileFromSelected(selectedFiles.indexOf(row.ref))" title="Upload this file">
                          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M14 10v2.667A1.333 1.333 0 0 1 12.667 14H3.333A1.333 1.333 0 0 1 2 12.667V10M11.333 5.333 8 2m0 0L4.667 5.333M8 2v8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                        </button>
                        <button type="button" class="btn-icon btn-delete-file" (click)="removeFile(selectedFiles.indexOf(row.ref))" title="Delete this file">
                          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M2 4H14M5.333 4V2.667C5.333 2.313 5.474 1.974 5.724 1.724C5.974 1.474 6.313 1.333 6.667 1.333H9.333C9.687 1.333 10.026 1.474 10.276 1.724C10.526 1.974 10.667 2.313 10.667 2.667V4M12.667 4V13.333C12.667 13.687 12.526 14.026 12.276 14.276C12.026 14.526 11.687 14.667 11.333 14.667H4.667C4.313 14.667 3.974 14.526 3.724 14.276C3.474 14.026 3.333 13.687 3.333 13.333V4H12.667Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                        </button>
                      </div>
                    </div>

                    <!-- Uploaded file row -->
                    <div
                      *ngIf="row.kind === 'uploaded'"
                      class="tree-row uploaded-file-item"
                      [style.padding-left.px]="8 + row.depth * 20"
                      [class.completed]="row.ref.status === 'completed'"
                      [class.error]="row.ref.status === 'error'"
                    >
                      <div class="file-info">
                        <div class="file-icon">
                          <ng-container *ngIf="row.ref.status !== 'completed'"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M14 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V8L14 2Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M14 2V8H20" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg></ng-container>
                          <ng-container *ngIf="row.ref.status === 'completed'"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20 6L9 17L4 12" stroke="#10b981" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></ng-container>
                        </div>
                        <div class="file-details">
                          <span class="file-name" [title]="getFilePath(row.ref.file)">{{ row.name }}</span>
                          <span class="file-size">{{ getFileSize(row.ref.file.size) }}</span>
                        </div>
                      </div>
                      <div class="file-actions">
                        <span class="file-status" [ngClass]="{
                          'status-pending': row.ref.status === 'pending',
                          'status-uploading': row.ref.status === 'uploading',
                          'status-completed': row.ref.status === 'completed',
                          'status-error': row.ref.status === 'error'
                        }">
                          {{ row.ref.progress }}%
                        </span>
                        <button *ngIf="row.ref.status === 'completed' && row.ref.previewData" type="button" class="btn btn-preview" (click)="openFilePreview(row.ref)" title="View Preview">
                          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M1 8C1 8 3 3 8 3C13 3 15 8 15 8C15 8 13 13 8 13C3 13 1 8 1 8Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                          <circle cx="8" cy="8" r="2" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                          Preview
                        </button>
                        <button type="button" class="btn btn-delete" (click)="deleteUploadedFile(row.ref)" title="Delete File">
                          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M2 4H14M5.333 4V2.667C5.333 2.313 5.474 1.974 5.724 1.724C5.974 1.474 6.313 1.333 6.667 1.333H9.333C9.687 1.333 10.026 1.474 10.276 1.724C10.526 1.974 10.667 2.313 10.667 2.667V4M12.667 4V13.333C12.667 13.687 12.526 14.026 12.276 14.276C12.026 14.526 11.687 14.667 11.333 14.667H4.667C4.313 14.667 3.974 14.526 3.724 14.276C3.474 14.026 3.333 13.687 3.333 13.333V4H12.667Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                        </button>
                      </div>
                      <div *ngIf="row.ref.status === 'uploading'" class="progress-bar">
                        <div class="progress-fill" [style.width.%]="row.ref.progress"></div>
                      </div>
                      <div *ngIf="row.ref.error" class="file-error">{{ row.ref.error }}</div>
                    </div>
                  </ng-container>
                </div>

                <!-- Actions stay outside the scroller so they are always reachable -->
                <div class="file-list-actions" *ngIf="selectedFiles.length > 0">
                  <button type="button" class="btn btn-clear" (click)="clearAllFiles()">Clear All</button>
                  <button type="button" class="btn btn-primary" (click)="uploadAllFiles()">Upload All ({{ selectedFiles.length }})</button>
                </div>
                <div *ngIf="selectedFiles.length === 0 && isAllCompleted() && !isPublished" class="post-upload-actions">
                  <button type="button" class="btn btn-secondary" (click)="uploadMoreFiles()">Upload More</button>
                </div>
              </div>
            </div>

            <!-- Ground Truth Upload (single .json or .csv file, shown when Upload File is selected) -->
            <div *ngIf="isUploadFileSelected()" class="file-upload-section">
              <div class="file-upload-header">
                <h3 class="file-upload-title">Ground Truth <span class="required-asterisk">*</span></h3>
                <p class="file-upload-subtitle">Upload the ground truth values (.json or .csv) used for evaluation. Required before publishing.</p>
              </div>

              <!-- Drag and Drop Area -->
              <div class="drop-area" *ngIf="!groundTruthItem">
                <div class="drop-message">
                  <div class="text-center">
                    <svg class="drop-icon" width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M21 15V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V15" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M7 10L12 5L17 10" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M12 5V17" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    <p class="drop-text">
                      Drag and drop your file here or
                      <button
                        type="button"
                        class="browse-button"
                        (click)="groundTruthInput.click()"
                      >
                        browse
                      </button>
                    </p>
                    <p class="file-types-hint">
                      Allowed File Types: <span class="file-types">JSON, CSV</span>
                    </p>
                  </div>
                </div>
                <input
                  #groundTruthInput
                  type="file"
                  accept=".json,.csv"
                  (change)="onGroundTruthSelected($event)"
                  class="d-none"
                />
              </div>

              <!-- Selected/Uploaded Ground Truth file -->
              <div *ngIf="groundTruthItem" class="selected-files-list">
                <div class="uploaded-files-container">
                  <div class="uploaded-file-item" [class.completed]="groundTruthItem.status === 'completed'" [class.error]="groundTruthItem.status === 'error'">
                    <div class="file-info">
                      <div class="file-icon">
                        <svg *ngIf="groundTruthItem.status !== 'completed'" width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M14 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V8L14 2Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M14 2V8H20" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                        <svg *ngIf="groundTruthItem.status === 'completed'" width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M20 6L9 17L4 12" stroke="#10b981" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                      </div>
                      <div class="file-details">
                        <span class="file-name">{{ groundTruthItem.file.name }}</span>
                        <span class="file-size">{{ getFileSize(groundTruthItem.file.size) }}</span>
                      </div>
                    </div>
                    <div class="file-actions">
                      <span class="file-status" [ngClass]="{
                        'status-pending': groundTruthItem.status === 'pending',
                        'status-uploading': groundTruthItem.status === 'uploading',
                        'status-completed': groundTruthItem.status === 'completed',
                        'status-error': groundTruthItem.status === 'error'
                      }">
                        {{ groundTruthItem.progress }}%
                      </span>
                      <button
                        *ngIf="groundTruthItem.status === 'pending' || groundTruthItem.status === 'error'"
                        type="button"
                        class="btn-icon btn-upload"
                        (click)="uploadGroundTruthFile()"
                        title="Upload this file"
                      >
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M14 10v2.667A1.333 1.333 0 0 1 12.667 14H3.333A1.333 1.333 0 0 1 2 12.667V10M11.333 5.333 8 2m0 0L4.667 5.333M8 2v8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                      </button>
                      <button
                        type="button"
                        class="btn btn-delete"
                        (click)="deleteGroundTruthFile()"
                        title="Remove File"
                      >
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M2 4H14M5.333 4V2.667C5.333 2.313 5.474 1.974 5.724 1.724C5.974 1.474 6.313 1.333 6.667 1.333H9.333C9.687 1.333 10.026 1.474 10.276 1.724C10.526 1.974 10.667 2.313 10.667 2.667V4M12.667 4V13.333C12.667 13.687 12.526 14.026 12.276 14.276C12.026 14.526 11.687 14.667 11.333 14.667H4.667C4.313 14.667 3.974 14.526 3.724 14.276C3.474 14.026 3.333 13.687 3.333 13.333V4H12.667Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                      </button>
                    </div>
                    <div *ngIf="groundTruthItem.status === 'uploading'" class="progress-bar">
                      <div class="progress-fill" [style.width.%]="groundTruthItem.progress"></div>
                    </div>
                    <div *ngIf="groundTruthItem.error" class="file-error">{{ groundTruthItem.error }}</div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Form actions are handled by the stepper's Publish button;
                 per-section Submit buttons have been removed -->
          </div>
        </ng-template>

        <!-- Stepper Component -->
        <app-stepper
          [steps]="stepperStepsWithLabel"
          [currentStep]="currentStep"
          [hidePreviousButton]="uploadedFiles.length > 0 && isAllCompleted()"
          [disableNextButton]="isPublishButtonDisabled()"
          [disablePublishButton]="isPublishButtonDisabled()"
          (stepChange)="onStepChange($event)"
          (next)="onNext()"
          (previous)="onPrevious()"
        ></app-stepper>
      </div>
    </div>
  </div>
</div>

<!-- File Preview Modal -->
<app-modal
  [(visible)]="previewModalOpen"
  [header]="'File Preview: ' + (previewingFile?.name || '')"
  [closable]="true"
  [width]="'90%'"
  [showFooter]="false"
  (onClose)="closePreview()"
>
  <div *ngIf="previewingFile" class="preview-modal-content">
    <!-- File metadata -->
    <div class="preview-metadata">
      <div class="metadata-item">
        <span class="metadata-label">File Name:</span>
        <span class="metadata-value">{{ previewingFile.name }}</span>
      </div>
      <div class="metadata-item">
        <span class="metadata-label">Size:</span>
        <span class="metadata-value">{{ getFileSize(previewingFile.size) }}</span>
      </div>
      <div class="metadata-item">
        <span class="metadata-label">Type:</span>
        <span class="metadata-value">{{ previewingFile.type || 'Unknown' }}</span>
      </div>
    </div>

    <!-- Preview content -->
    <div class="preview-content">
      <!-- Table view for CSV/structured data using NHA table style -->
      <div *ngIf="previewingFile.parsedData && previewingFile.parsedData.headers.length > 0" class="details-tab--table-wrapper">
        <div class="details-tab--table-container">
          <table class="details-tab--table">
            <thead>
              <tr>
                <th *ngFor="let header of previewingFile.parsedData.headers">{{ header }}</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of previewingFile.parsedData.rows; let i = index">
                <td *ngFor="let cell of row">{{ cell }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- Fallback: JSON view for non-CSV data -->
      <div *ngIf="previewingFile.previewData && (!previewingFile.parsedData || previewingFile.parsedData.headers.length === 0)" class="preview-json-wrapper">
        <pre>{{ previewingFile.previewData | json }}</pre>
      </div>

      <!-- No preview available -->
      <div *ngIf="!previewingFile.previewData" class="preview-unavailable">
        <p>Preview not available for this file</p>
      </div>
    </div>
  </div>
</app-modal>

<!-- Publish Success Modal -->
<app-confirmation-dialog
  [(visible)]="isPublishSuccessModalOpen"
  type="success"
  themeColor="green"
  [title]="getSuccessTitle()"
  [message]="getSuccessMessage()"
  [confirmLabel]="getViewButtonLabel()"
  secondaryActionLabel="Create New"
  [showSecondaryAction]="true"
  [showCancelButton]="false"
  [closable]="false"
  [width]="'540px'"
  (onConfirm)="onViewDataset()"
  (onSecondaryAction)="onCreateNew()"
  (onClose)="closePublishSuccessModal()"
></app-confirmation-dialog>

<!-- SFTP/API Integration Request Success Modal -->
<app-confirmation-dialog
  [(visible)]="isUploadSuccessModalOpen"
  type="success"
  themeColor="green"
  title="Request sent to Platform Admin"
  [message]="'Your ' + requestTypeName + ' has been successfully submitted to the Platform Administrator.<br><br>Your request is awaiting approval from the Admin.'"
  nextStepsTitle="What happens next?"
  [nextStepsMessage]="getNextStepsMessage()"
  [confirmLabel]="getViewButtonLabel()"
  secondaryActionLabel="Create New"
  [showSecondaryAction]="true"
  [showCancelButton]="false"
  [closable]="false"
  [width]="'540px'"
  (onConfirm)="onViewDatasetFromRequest()"
  (onSecondaryAction)="onCreateNewFromRequest()"
  (onClose)="closeUploadSuccessModal()"
></app-confirmation-dialog>

<!-- Direct Push Success Modal -->
<app-confirmation-dialog
  [(visible)]="isDirectPushSuccessModalOpen"
  type="success"
  themeColor="green"
  [title]="getSuccessTitle()"
  [message]="getSuccessMessage()"
  [confirmLabel]="getViewButtonLabel()"
  secondaryActionLabel="Create New"
  [showSecondaryAction]="true"
  [showCancelButton]="false"
  [closable]="false"
  [width]="'540px'"
  (onConfirm)="onViewDatasetFromDirectPush()"
  (onSecondaryAction)="onCreateNewFromDirectPush()"
  (onClose)="closeDirectPushSuccessModal()"
></app-confirmation-dialog>

